import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  padding: 4px;\n  cursor: pointer;\n  justify-content: flex-start;\n  align-items: center;\n  line-height: ', ';\n  &:hover {\n    background-color: ', ';\n  }\n  ', '\n'], ['\n  display: flex;\n  flex-direction: row;\n  padding: 4px;\n  cursor: pointer;\n  justify-content: flex-start;\n  align-items: center;\n  line-height: ', ';\n  &:hover {\n    background-color: ', ';\n  }\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n      opacity: 0.5;\n      cursor: not-allowed;\n      &:hover {\n        background-color: transparent;\n      }\n    '], ['\n      opacity: 0.5;\n      cursor: not-allowed;\n      &:hover {\n        background-color: transparent;\n      }\n    ']);

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { styles } from 'gipsy-misc';

var ContextMenuItem = function (_PureComponent) {
  _inherits(ContextMenuItem, _PureComponent);

  function ContextMenuItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ContextMenuItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ContextMenuItem.__proto__ || Object.getPrototypeOf(ContextMenuItem)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ContextMenuItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          height = _props.height,
          disabled = _props.disabled;

      return React.createElement(
        Container,
        { className: 'context-menu-item', onClick: this.onClick, height: height, disabled: disabled },
        this.props.children
      );
    }
  }]);

  return ContextMenuItem;
}(PureComponent);

ContextMenuItem.propTypes = {
  disabled: PropTypes.bool,
  height: PropTypes.number.isRequired,
  onClick: PropTypes.func
};
ContextMenuItem.defaultProps = {
  height: 20
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onClick = function (args) {
    var _props2 = _this2.props,
        onClick = _props2.onClick,
        disabled = _props2.disabled;

    if (!disabled && onClick) {
      onClick(args);
    }
  };
};

export default ContextMenuItem;


var Container = styled.div(_templateObject, function (_ref2) {
  var height = _ref2.height;
  return height + 'px';
}, styles.colors.veryLightGrey, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled && css(_templateObject2);
});
//# sourceMappingURL=ContextMenuItem.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/ContextMenu/ContextMenuItem.js
// module id = 820
// module chunks = 0